import { DsText } from "@mvp/design-system";
import React from "react";
import { PhoneNumber } from "../../PhoneNumber";
import { ContentTitle } from "./ContentTitle";
import { phoneNumbers } from "../../../store/constants";
import { useEligibilityStore } from "../../../hooks/useEligibilityStore";
import { Trans, useTranslation } from 'react-i18next';
import { QualifyingLifeEventType } from "../../../store/constants";

export const LifeEventContent: React.FC = () => {

    const { eligibilityStore: { qualifyingLifeEvent : { eventType } } } = useEligibilityStore();
    const { t } = useTranslation();

    return (
        <>
            <ContentTitle text={t('modal.title')} />
            <DsText variant="body1" >
                <Trans
                    t={t}
                    i18nKey="modal.lifeEvent.text"
                    values={{
                        type: t(`modal.lifeEvent.types.${QualifyingLifeEventType[Number(eventType)]}`),
                    }}
                    components={{
                        PhoneComponent: <PhoneNumber
                            color="primary"
                            variant="button"
                            phoneNumber={phoneNumbers.talkMVP}
                        />,
                    }}
                />
            </DsText>
        </>
    );
};
